const fromdata = [{
		title: "",
		modelvalue: "",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#424E66",
		lableheight: 0,
		types: "text",
		placeholder: "请输入主分类名称",
		width: 750,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 0,
		X: false,
	},
	{
		title: "",
		modelvalue: "",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#424E66",
		lableheight: 0,
		types: "text",
		placeholder: "请输入分类备注",
		width: 750,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 0,
		X: false,
	}, {
		modelvalue: "",
		title: '',
		fontSize: '14px',
		color: '#333333',
		placeholder: '产品线',
		multiple: true,
		types: '',
		inputflag: true,
		inputtype: 'select',
		width: 762,
		marginLeft: 5,
		marginTop: 8,
		options: []
	},
];
export default fromdata;
